import {Button, Col, Row} from "reactstrap";
import useApiCallService from "../../Common/Helpers/ApiCall";
import {useEffect, useState} from "react";
import RequestUserSettingsModel from "../Model/Request/RequestUserSettingsModel";
import {CustomInput} from "../../Common/Components/Input/CustomInput";
import {CustomSubmitButton} from "../../Common/Components/Input/CustomSubmitButton";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import {FlashMessage} from "../../Common/Helpers/FlashMessage";
import ResponseUserSettingsModel from "../Model/Response/ResponseUserSettingsModel";
import $ from "jquery";
import {useTranslation} from "react-i18next";
import i18next from "i18next";
import {LoadLocalStorage} from "../../Common/Helpers/LoadLocalStorage";
import i18n from "i18next";
import Select from 'react-select';
import { InfoPageMessage } from "../../Common/Components/Button/InfoPageMessage";
import { CustomReload } from "../../AppSystem/Helpers/CustomReload";
import { CustomModal } from "../../Common/Components/Modal/CustomModal";
import { QRCode } from 'react-qr-code';
import { useSelector } from "react-redux";


export function SettingsTest() {
    const { t } = useTranslation();

    useEffect(() => {
        if (i18next.language !== LoadLocalStorage('selectedLanguage')){
            i18n.changeLanguage(LoadLocalStorage('selectedLanguage'));
        }
    }, []);
    const {userData} = useSelector(state => state.auth);
    const {ApiCall} = useApiCallService();
    // REQUESTS
    const [requestUserSettings, setRequestUserSettings] = useState(new RequestUserSettingsModel());

    // API RESPONSES
    const [responseUserSettings, setResponseUserSettings] = useState(new ResponseUserSettingsModel());

    //GET USER SETTING
    const [done, setDone] = useState(false);

    //MODALS
    const [displaySendModal, setDisplaySendModal] = useState(false);
    const [displaySendQrModal, setDisplaySendQrModal] = useState(false);

    const [responseQr, setResponseQr] = useState('');

    //EDIT MODE
    const [editModeSettings, setEditModeSettings] = useState(false);
    const [checkClickButton, setCheckClickButton] = useState(false);

    // VALIDATION ACCOUNT NUMBER OPEN PAYMENT
    const [showSignButton, setShowSignButton] = useState(false);
    const [showDropdownBank, setShowDropdownBank] = useState(false);
    const [showImgBank, setShowImgBank] = useState(false);
    const [imgBank, setImgBank] = useState(false);
    const [bankValue, setBankValue] = useState('');
    const [consentResponse, setConsentResponse] = useState('');

     const [banks, setBanks] = useState([]);
     const [bankOptions, setBankOptions] = useState([]);
     

    // VALIDATION SCHEMAS
    const completeSchemaUserSetting = RequestUserSettingsModel.getAttributes( null, true);

    const clearingNumberInput = document.getElementById('clearingNumber');
    if (clearingNumberInput) {
        clearingNumberInput.addEventListener('keypress', function (e) {
            const key = e.key;
            
            if (key < '0' || key > '9') {
                e.preventDefault();
                return;
            }

            const currentValue = clearingNumberInput.value;
            const newValue = currentValue + key;
            const digitsOnly = newValue.replace(/[^0-9]/g, '');
            
            const maxLength = (digitsOnly[0] === '8') ? 5 : 4;

            if (digitsOnly.length > maxLength) {
                e.preventDefault();
            }
        });
    }


    const accountNumberInput = document.getElementById('accountNumber');
    if (accountNumberInput) {
        accountNumberInput.addEventListener('keypress', function (e) {
            const key = e.key;
            const currentValue = accountNumberInput.value;

            const isValidChar = (key >= '0' && key <= '9')/* || key === '.' || key === ','*/;
            const hasReachedMaxLength = currentValue.replace(/[^0-9]/g, '').length >= 12;

            if (!isValidChar || hasReachedMaxLength) {
                e.preventDefault();
            }

        });
    }

    //GET BANKS LIST
    useEffect(() => {
            const handleBankListResponse = (response) => {
                if (response) {
                    setBanks(response.aspsps);
                    const opciones = response.aspsps.map((banco) => ({
                    value: banco.bicFi,
                    label: banco.name,
                    }));
                    setBankOptions(opciones);
                }
            };

            const CostApiCall = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/open-payment/aspsp-list",
                    };
                    await ApiCall(apiCallOptions, handleBankListResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };

            CostApiCall();
    }, []);

    const SubmitSettings = async () => {
        try {
            await completeSchemaUserSetting.validate(requestUserSettings, { abortEarly: false });
            $('#submitUserSettings').prop('disabled', true);

            if (requestUserSettings.accountNumber !== "") {
                const apiCallOptions = {
                    method: "post",
                    url: "/usersetting/bank-account",
                    data: requestUserSettings,
                };
                try {
                    await ApiCall(apiCallOptions, setResponseUserSettings);
                    FlashMessage(  t('validationMessage.bankAccountSave'), 'flash-messageSuccess');
                } catch (error) {
                    console.log(error);
                     FlashMessage(t('validationMessage.sendErrorShort'), 'flash-messageError');
                }
            }
        } catch (err) {
            console.log(err)
        }
    };


    const HandleChange = (e, name) => {
        let value = e.target.value;
        setRequestUserSettings((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    }


    //Edit
    const EditSettings = async () => {
        try {
            await completeSchemaUserSetting.validate(requestUserSettings, { abortEarly: false });
            $('#editUserSettings').prop('disabled', true);

            if (requestUserSettings.accountNumber !== "") {
                const apiCallOptions = {
                    method: "put",
                    url: "/usersetting/bank-account",
                    data: requestUserSettings,
                };
                try {
                    await ApiCall(apiCallOptions, setResponseUserSettings);

                } catch (error) {
                    console.log(error);
                    FlashMessage(t('validationMessage.sendErrorShort'), 'flash-messageError');
                }
            }
        } catch (err) {
            console.log(err)
        }
    };


    //GET USER SETTING
    useEffect(() => {
        if(responseUserSettings !== null && responseUserSettings.clearingNumber === ''){
            const handleUserSettingsResponse = (responseUserSettings) => {
                if(responseUserSettings !== null) {
                    setResponseUserSettings(responseUserSettings);
                }
            };

            const CostApiCall = async () => {
                try {
                    const apiCallOptions = {
                        method: "get",
                        url: "/usersetting/bank-account",
                    };
                    await ApiCall(apiCallOptions, handleUserSettingsResponse);
                } catch (error) {
                    console.log('error', error);
                }
            };

            CostApiCall();
        }
    }, [responseUserSettings]);


    useEffect(() => {
        if(responseUserSettings === null) {
            FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
        }
        if(responseUserSettings !== null && responseUserSettings.clearingNumber !== '' && checkClickButton === true) {
            setDone(true);
        }
    }, [responseUserSettings]);


    useEffect(() => {
        if (done === true) {
            FlashMessage(  t('validationMessage.bankAccountUpdate'), 'flash-messageSuccess');
            setEditModeSettings(false);
            setDone(false);
            $('#editUserSettings').prop('disabled', false);
        }
    }, [done]);


    useEffect(() => {
        if(consentResponse === null) {
            FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
        }     
        
        if (typeof consentResponse === 'string' && consentResponse.trim() !== '') {
            if(consentResponse.startsWith('bankid')) {
                setResponseQr(consentResponse);
                setDisplaySendQrModal(true);
            }
            else{
                window.open(consentResponse, '_blank');
            }
            
        }

    }, [consentResponse]);


    const ValidateAccountOpenPayment = async (accountId) => {

        const handleUserSettingsResponse = (responseUserSettings) => {
            if(responseUserSettings !== null) {
                setResponseUserSettings(responseUserSettings);
                $('#validatedAccountButton').prop('disabled', false);
                CustomReload();
            }
        };

        try {
            $('#validatedAccountButton').prop('disabled', true);

            if (accountId !== "") {
                const requestValidatedAccount = {
                    accountId: accountId,
                }

                const apiCallOptions = {
                    method: "put",
                    url: "/usersetting/bank-account/validated",
                    data: requestValidatedAccount,
                };
                try {
                    await ApiCall(apiCallOptions, handleUserSettingsResponse);

                } catch (error) {
                    console.log(error);
                    FlashMessage(t('validationMessage.sendErrorShort'), 'flash-messageError');
                }
            }
        } catch (err) {
            console.log(err)
        }
    };

    const DeleteIban = async () => {

        const handleUserSettingsResponse = (responseUserSettings) => {
            if(responseUserSettings !== null) {
                setResponseUserSettings(responseUserSettings);
                $('#validatedAccountButton').prop('disabled', false);
                CustomReload();
            }
        };

        try {
            $('#validatedAccountButton').prop('disabled', true);

            const apiCallOptions = {
                method: "delete",
                url: "/usersetting/bank-account/delete",
            };
            try {
                await ApiCall(apiCallOptions, handleUserSettingsResponse);

            } catch (error) {
                console.log(error);
                FlashMessage(t('validationMessage.sendErrorShort'), 'flash-messageError');
            }
            
        } catch (err) {
            console.log(err)
        }
    };


    const SubmitData = async () => {
        try {
            $('#submitData').prop('disabled', true);

            if (bankValue) {
                const apiCallOptions = {
                    method: "get",
                    url: "/open-payment/consent/create?bicFi=" + bankValue,
                };
                try {
                    await ApiCall(apiCallOptions, setConsentResponse);
                    FlashMessage(  t('validationMessage.bankAccountSave'), 'flash-messageSuccess');
                } catch (error) {
                    console.log(error);
                     FlashMessage(t('validationMessage.sendErrorShort'), 'flash-messageError');
                }
            }
        } catch (err) {
            console.log(err)
        }
    };

    const handleGroupByDropdownChange = (selectedOption) => {
        if(selectedOption && selectedOption.value) {    
            $('#submitData').prop('disabled', false);   

            const bancoSeleccionado = banks.find(
                    (b) => b.bicFi === selectedOption.value
                );

            if (bancoSeleccionado) {
                setImgBank(bancoSeleccionado.logoUrl);
            } else {
                setImgBank('');
            }         

            setShowImgBank(true);
            setShowSignButton(true);
            setBankValue(selectedOption?.value);
            return;
        }
        else{
            setShowImgBank(false);
            setShowSignButton(false);
        }
    };    

     const renderActionColumn = (item) => {
        return (
            <>             
                <CustomButton icon = "bx bx-check py-1" iconColor="#157553" hoverIconColor='white' hoverButtonColor='#A3C2B8' iconSize={4}  buttonColor="#cde0da"  tooltipText={t('button.info')} customClasses="rounded" buttonBorder={false} id='validatedAccountButton' onClick={() => {
                             ValidateAccountOpenPayment(item.accountId);   
                            }} />
            </>
        );
    }

    const modalSendContent = (
        <div id="sendMessageDiv">
            {t('userSetting.deleteIabn')}
        </div>
    );
    const modalSendFooter = (
        <>
            <Button className="box-green border-0" id="sendButton" onClick={async () => {
                await DeleteIban();
            }}>
                {t('button.send')}
            </Button>
            <Button className="box-red border-0" onClick={() => {
                setDisplaySendModal(false)
                $("#forms").removeClass("d-none");
            }}>{t('button.cancel')}</Button>
        </>
    );

    const modalSendQrContent = (
        <>
            <h5 className="text-center mb-5">Skanna följande QR-kod med din telefon, vilket öppnar din Bank-ID-applikation och där bör du fortsätta autentiseringsprocessen.</h5>
            <div style={{ height: "auto", margin: "0 auto", maxWidth: 250, width: "100%" }}>
                <QRCode
                    value={responseQr}
                    size={200}            // tamaño en píxeles (ancho y alto)
                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    viewBox={`0 0 256 256`}
                />
            </div>
        </>
    );
    const modalSendQrFooter = (
        <>
            <Button className="box-red border-0" onClick={() => {
                setDisplaySendQrModal(false)
            }}>{t('button.cancel')}</Button>
        </>
    );

    return(
        <Col lg={12} className='card card-backend p-4 mb-5'>
            <CustomModal isOpen={displaySendModal} toggle={() => setDisplaySendModal(!displaySendModal)} body={modalSendContent} footer={modalSendFooter} />
            <CustomModal isOpen={displaySendQrModal} toggle={() => setDisplaySendQrModal(!displaySendQrModal)} body={modalSendQrContent} footer={modalSendQrFooter}/>
            <Row>
                <Row className="mt-4">
                    <Col lg='4'>
                        <Row>
                            <Col lg='8'>
                                <h2>{t('userSetting.bankAccount')}</h2>                      
                            </Col>
                            <Col lg='1' className='text-end'>
                                {responseUserSettings.warning ? 
                                    <button  className="rounded me-2 py-2 border-0 text-red bg-transparent p-custom-button position-relative class-approve" >
                                        <i className="bx bx-error pb-custom align-middle size-icon-custom-button" />
                                        <div className="tooltip-custom-button-error-bank-account">
                                            {<pre className="font-size-12">{responseUserSettings.warning}</pre>}
                                        </div>
                                    </button>
                                    : ''}
                            </Col>
                            <Col lg='3' className='text-end pl-0'>
                                {responseUserSettings !== null && responseUserSettings.clearingNumber !== '' && editModeSettings === false ?
                                    <CustomButton text="" icon='bx bx-edit py-1' iconColor='#157553'
                                                iconSize={5} buttonColor='#bed1cd'
                                                buttonRadius={3} hoverButtonRadius={3}
                                                hoverIconColor='white' hoverButtonColor='#157553'
                                                customClasses="ms-3 border-0"
                                                tooltipText={t('button.edit')}
                                                onClick={() => {
                                                    setEditModeSettings( true);
                                                    setRequestUserSettings(responseUserSettings);
                                                }}/>
                                    :
                                    ''
                                }
                                {editModeSettings === true ?
                                    <>
                                        <CustomButton icon='bx bx-undo py-1' iconColor='#EB5757' iconSize={5} buttonColor='#e9cbcd' buttonRadius={3} hoverButtonRadius={3} hoverIconColor='white' hoverButtonColor='#EB5757' customClasses="border-0"  tooltipText={t('button.cancel')} onClick={() => { setEditModeSettings(false) }}/>
                                        <CustomButton text="" icon='bx bx-check py-1' iconColor='#157553' id='editUserSettings'
                                                    iconSize={5} buttonColor='#bed1cd'
                                                    buttonRadius={3} hoverButtonRadius={3}
                                                    hoverIconColor='white' hoverButtonColor='#157553'
                                                    customClasses="ms-3 border-0"
                                                    tooltipText={t('button.save')}
                                                    onClick={async () => {
                                                        await EditSettings();
                                                        setCheckClickButton(true);
                                                    }}/>
                                    </>
                                    :
                                    ''
                                }                            
                            </Col>
                        </Row>
                        {responseUserSettings !== null && responseUserSettings.clearingNumber !== '' && editModeSettings === false ? (
                            <>
                                <Col lg={12}>
                                    <div className="fw-bold pb-1">{t('userSetting.modelClearingNumber')}</div>
                                    <div className="box-grey">{responseUserSettings.clearingNumber}</div>
                                </Col>
                                <Col lg={12} className='pt-3'>
                                    <div className="fw-bold pb-1">{t('userSetting.modelAccountNumber')}</div>
                                    <div className="box-grey">{responseUserSettings.accountNumber}</div>
                                </Col>
                                {responseUserSettings.iban ?  
                                <Col lg={12} className='pt-3'>
                                    <Row>
                                        <div className="fw-bold pb-1">IBAN</div>
                                        
                                    </Row>
                                    <div className="box-grey">{responseUserSettings.iban}</div>
                                </Col>
                                : ''}
                            </>
                            ) : (
                            <>
                                <CustomInput
                                    model={RequestUserSettingsModel}
                                    attribute='clearingNumber'
                                    data={responseUserSettings?.clearingNumber || ''}
                                    customChange={(e) => HandleChange(e, 'clearingNumber')}
                                />
                                <CustomInput
                                    model={RequestUserSettingsModel}
                                    attribute='accountNumber'
                                    data={responseUserSettings?.accountNumber || ''}
                                    customChange={(e) => HandleChange(e, 'accountNumber')}
                                />
                                {/* {responseUserSettings.iban ?  
                                <Row className='pt-3'>
                                    <Col lg={11} className='pt-3'>
                                        <div className="fw-bold pb-1">IBAN</div>
                                        <div className="box-grey">{responseUserSettings.iban}</div>
                                    </Col>
                                    <Col Col lg={1} className="d-flex flex-column justify-content-end align-items-end">
                                        <CustomButton icon='bx bx-x py-2' iconColor='#EB5757' iconSize={5} buttonColor='#e9cbcd' buttonRadius={3} hoverButtonRadius={3} hoverIconColor='white' hoverButtonColor='#EB5757' customClasses="border-0"  tooltipText={t('button.cancel')} onClick={() => { setDisplaySendModal(true) }}/>
                                    </Col>
                                </Row>
                                : ''} */}
                            </>
                        )}

                        {(responseUserSettings !== null && responseUserSettings.clearingNumber === '') || responseUserSettings === null ?
                            <Col lg={12} className='text-end'>
                                <CustomSubmitButton text={t('button.save')} id='submitUserSettings'
                                                    customClick={async () => {
                                                        await SubmitSettings();
                                                        setCheckClickButton(true);
                                                    }}/>
                            </Col>
                            :
                            ''
                        } 
                         {userData.pnr && userData.pnr.length === 12 ?                     
                        <Col lg={12} className='text-start mt-4'>
                            <CustomButton text={t('userSetting.validateAccountButton')} id='submitDatas'
                                                onClick={async () => {                                                
                                                    setShowDropdownBank(true);
                            }}/>
                        </Col>
                        :
                        ''}
                          
                        {showDropdownBank ?
                        <Row className="mt-5">
                            <Col lg={8} >                        
                                <h5>{t('userSetting.validateAccountTitle')}</h5>                                           
                            </Col>
                            {(showImgBank)  ?
                                <Col lg={4} className='d-flex justify-content-end align-items-end'>                                           
                                    <img src={imgBank} 
                                        alt="Descripción de la imagen" 
                                        style={{ width: '90%', height: 'auto' }} 
                                    />    
                                </Col>:
                                    ''
                            } 
                            <Col lg={8} className='text-start mt-2'>                  
                                <div className="filters-grid" style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(270px, 1fr))',gap: '1rem',   }} > 
                                    <div>
                                        <label className='ms-0'>{t('userSetting.selectBank')}</label>                       
                                        <Select
                                            onChange={handleGroupByDropdownChange}
                                            options={bankOptions}
                                            placeholder="Ej valt"
                                            isClearable={true}
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: 'rgba(21, 117, 83, 0.25)',
                                                    primary: '#67a58f', 
                                                    neutral0: 'var(--bs-body-bg)', 
                                                    neutral80: 'var(--bs-body-color)',
                                                },
                                            })}
                                        />
                                    </div>
                                </div>   
                            </Col>                   
                            {(showSignButton)  ?
                                <Col lg={4} className='d-flex justify-content-end align-items-end px-3 '>
                                    <CustomSubmitButton text={t('openPayment.sign')} id='submitData'
                                                        customClick={async () => {
                                                            await SubmitData();
                                                        }}/>
                                </Col>
                                :
                                ''
                            }
                            </Row> 
                            :
                            ''
                        }  
                    </Col>
                    {editModeSettings === false?
                        <Col lg={8} className="col-8 text-end">
                            <InfoPageMessage message={t('userSetting.infoMessage')}/>                    
                        </Col>
                        :
                        ''
                        }
                </Row>                         
            </Row>         
        </Col>
    );
}
